<div>
  <form class="container-style needs-validation" novalidate [formGroup]="formChargeAccount">
    <div class="row">
      <div class="custom-container col-lg-3 col-md-4 col-sm-6 col-6">
        <app-custom-datepicker formControlName="dateAnnul" [labelText]="'Fecha'"
          [required]="true"></app-custom-datepicker>
      </div>
      <div class="custom-container col-lg-9 col-md-8 col-sm-12 col-12">
        <app-custom-select formControlName="conceptAnnulId" [labelText]="'Tipo'" [list]="listConcepts" [required]="true"
          (onChangeSelect)="getConcept($event)"></app-custom-select>
      </div>
      <div class="custom-container col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-textarea formControlName="observationAnnul" [labelText]="'Observación'"></app-custom-textarea>
      </div>
      <div class="custom-container col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2">
        <app-custom-button [title]="'Anular'" [label]="'Anular'" [disabled]="disableButton" [severity]="'danger'"
          (onClick)="annulChargeAccount()"></app-custom-button>
      </div>
    </div>
  </form>
</div>